var s = /* @__PURE__ */ ((E) => (E.BUSINESS_CREATED = "business_created", E.BUSINESS_UPDATED = "business_updated", E.BUSINESS_DELETED = "business_deleted", E.MESSAGE_UPDATED = "message_updated", E.MESSAGE_CREATED = "message_created", E.LEAD_RECEIVED = "lead_received", E))(s || {});
export {
  s as WebhookEventType
};
